import { createAction } from "typesafe-actions";
import type { ParamsType } from "./types";

export const setUrlParams = createAction("@@appi/query-params/set-query-params")<Partial<ParamsType>>();
export const resetUrlParams = createAction("@@appi/query-params/reset-query-params")();
